import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill, PiPlus, PiUser } from 'react-icons/pi';
import { IArtistResponse } from 'services/artists/types';
import { STATUS } from 'services/types';
import './ArtistSearchCard.scss';

interface IArtistSearchCardProps {
  artist?: IArtistResponse;
  isSelected?: boolean;
  onClick?: (artist?: IArtistResponse) => void;
}

const ArtistSearchCard = ({ artist, isSelected, onClick }: IArtistSearchCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(['artist-search-card'], { isSelected })}
      onClick={() => onClick && onClick(artist)}
    >
      <div className="artist-search-card-profile">
        {artist?.profilePictureLink ? (
          <img src={artist.profilePictureLink} />
        ) : artist ? (
          <PiUser />
        ) : (
          <PiPlus />
        )}
      </div>

      <div className="artist-search-card-header">
        <div className="artist-search-card-header-title">
          {artist?.nickname ?? t('button.add-new-artist')}
        </div>
        <div className="artist-search-card-header-description">
          <div className="artist-search-card-header-description-content">
            {artist
              ? t(`enum.STATUS.${STATUS[artist.artistStatus]}`)
              : t('button.fill-simple-form')}
          </div>
        </div>
      </div>
      {artist && <>{isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}</>}
    </div>
  );
};

export default ArtistSearchCard;
